import { render, staticRenderFns } from "./HeatmapType.vue?vue&type=template&id=af024fee&scoped=true"
import script from "./HeatmapType.vue?vue&type=script&lang=js"
export * from "./HeatmapType.vue?vue&type=script&lang=js"
import style0 from "./HeatmapType.vue?vue&type=style&index=0&id=af024fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af024fee",
  null
  
)

export default component.exports